import { escapeHtml, escapeUrl } from "app/components/favourite-layout/favourite/common/utils";

export const downloadFile = (blob: Blob, filenameWithExtension: string) => {
  if (!blob) {
    return;
  }
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = escapeUrl(objectUrl);
  anchor.download = escapeHtml(filenameWithExtension);
  document.body.appendChild(anchor);
  anchor.click();

  setTimeout(() => {
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(objectUrl);
  }, 0);
};
